import React from 'react';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../library/form/components/FormLabel'
import DocRowContainer from '../../../cmn/DocRowContainer'

const UserDeviceRow = (props) => {
    const { formObject, rowKey } = props;

    return (
        <li className='uiDivider'>
            <DocRowContainer formObject={formObject} rowKey={rowKey} 
                containerClass="uiSpacer5 uiBoxHiddenAction" 
                actionClass="uiActionBlock">
                <div>
                    <div className="uiSpacer10">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "macAdd" }} value="Device MAC Address" />
                        </span>

                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "macAdd" }}
                            id='svAddType' className="uiInline uiHeaderElement"
                        />
                    </div>
                    <div className="uiSpacer5">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "deviceDetail" }} value="Device Detail" />
                        </span>

                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "deviceDetail" }}
                            id='svAddType' className="uiInline uiHeaderElement"
                        />
                    </div>
                    <div className="uiSpacer5">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "loginInfo" }} value="Device Last Login" />
                        </span>

                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "loginInfo" }}
                            id='svAddType' className="uiInline uiHeaderElement"
                        />
                    </div>
                    <div className="uiSpacer5">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isLoggedOn" }} value="Is Logged On" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "isLoggedOn" }}
                            id='svAddType' className="uiInline uiHeaderElement"
                        />
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isActive" }} value="Is Active" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "isActive" }}
                            id='svAddType' className="uiInline uiHeaderElement"
                        />
                    </div>
                </div>
            </DocRowContainer>
        </li>

    )
}

export default UserDeviceRow